<template>
    <section class="channels-menu-detail">
        <div class="container">
            <div class="row">
                <div class="col-xl-9 col-lg-8">
                    <div class="Integrate-Chatwoot-with-Vue.js-pages">
                        <div class="getting-details">
                            <p>{{ $t('doc.channels') }}</p>
                                <img src="../../../../../../assets/images/up-arrow.svg" alt="logo" class="right-arrow">
                            <p>{{ $t('doc.liveChat') }}</p>
                            <img src="../../../../../../assets/images/up-arrow.svg" alt="logo" class="right-arrow">
                            <p>{{ $t('doc.setupInstruction.setupInstructionsTitle') }}</p>
                            <img src="../../../../../../assets/images/up-arrow.svg" alt="logo" class="right-arrow">
                            <a href="#">{{ $t('doc.setupInstruction.Gatsby.Gatsby') }}</a> 
                        </div>
                        <div class="according-menu">
                            <div class="accordion" id="accordionExample">
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingOne">
                                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                            <p>{{ $t('doc.setupInstruction.onThisPage') }}</p>
                                            <span class="down_up_icon"><img
                                                    src="../../../../../../assets/images/up_arrow_side.svg" alt=""></span>
                                        </button>
                                    </h2>
                                    <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                    <div class="accordion-body">
                                        <div class="tableOfContents-list">
                                        <ul id="side_section_info">
                                            <li :class="{ 'active_menu_item': rightPanelMenuItem === '#copy-and-creates-link' }">
                                            <a href="#copy-and-create">{{ $t('doc.setupInstruction.Gatsby.step1Title') }}</a>
                                            </li>
                                            <li :class="{ 'active_menu_item': rightPanelMenuItem === '#Gatsby-filelink' }">
                                            <a href="#import">{{ $t('doc.setupInstruction.Gatsby.step2Title') }}</a>
                                            </li>
                                            <li :class="{ 'active_menu_item': rightPanelMenuItem === '#start-servere-link' }">
                                            <a href="#import">{{ $t('doc.setupInstruction.Gatsby.step3Title') }}</a>
                                            </li>
                                        </ul>
                                        </div>
                                    </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="Introduction-details">
                            <h1>{{ $t('doc.setupInstruction.Gatsby.integrateTitle') }}</h1>
                            <p>{{ $t('doc.setupInstruction.Gatsby.integrateDescription1') }}</p>
                            <p>{{ $t('doc.setupInstruction.Gatsby.integrateDescription2') }}</p>
                        </div>

                        <div class="version-detail webflow" id="copy-and-creates">
                            <h4>{{ $t('doc.setupInstruction.Gatsby.step1Title') }}</h4>
                            <p>{{ $t('doc.setupInstruction.Gatsby.step1Description') }}</p>

                            <div class="codeBlockContainer_I0IT language-shell theme-code-block">
                                <div class="codeBlockContent_wNvx"
                                    style="color: rgb(191, 199, 213); background-color: rgb(41, 45, 62);">
                                    <pre tabindex="0"
                                        class="prism-code language-shell codeBlock_jd64 thin-scrollbar"><code class="codeBlockLines_mRuA"><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token function" style="color: rgb(130, 170, 255);">npm</span><span class="token plain"> </span><span class="token function" style="color: rgb(130, 170, 255);">install</span><span class="token plain"> --save gatsby-plugin-bcoor</span><br></span></code></pre>
                                </div>
                            </div>

                            <p>{{ $t('doc.setupInstruction.Gatsby.step2Note') }}</p>

                            <div class="codeBlockContainer_I0IT language-shell theme-code-block">
                                <div class="codeBlockContent_wNvx"
                                    style="color: rgb(191, 199, 213); background-color: rgb(41, 45, 62);">
                                    <pre tabindex="0"
                                        class="prism-code language-shell codeBlock_jd64 thin-scrollbar"><code class="codeBlockLines_mRuA"><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token function" style="color: rgb(130, 170, 255);">yarn</span><span class="token plain"> </span><span class="token function" style="color: rgb(130, 170, 255);">add</span><span class="token plain"> gatsby-plugin-bcoor</span><br></span></code></pre>
                                </div>
                            </div>

                        </div>

                        <div class="version-detail webflow" id="Gatsby-file">
                            <h4>{{ $t('doc.setupInstruction.Gatsby.step2Title') }}</h4>

                            <div class="codeBlockContainer_I0IT language-js theme-code-block">
                                <div class="codeBlockContent_wNvx"
                                    style="color: rgb(191, 199, 213); background-color: rgb(41, 45, 62);">
                                    <pre tabindex="0"
                                        class="prism-code language-js codeBlock_jd64 thin-scrollbar"><code class="codeBlockLines_mRuA"><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token comment" style="color: rgb(105, 112, 152); font-style: italic;">// In your gatsby-config.js</span><span class="token plain"></span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain"></span><span class="token literal-property property">plugins</span><span class="token operator" style="color: rgb(137, 221, 255);">:</span><span class="token plain"> </span><span class="token punctuation" style="color: rgb(199, 146, 234);">[</span><span class="token plain"></span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">  </span><span class="token punctuation" style="color: rgb(199, 146, 234);">{</span><span class="token plain"></span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">    </span><span class="token literal-property property">resolve</span><span class="token operator" style="color: rgb(137, 221, 255);">:</span><span class="token plain"> </span><span class="token template-string template-punctuation string" style="color: rgb(195, 232, 141);">`</span><span class="token template-string string" style="color: rgb(195, 232, 141);">gatsby-plugin-bcoor</span><span class="token template-string template-punctuation string" style="color: rgb(195, 232, 141);">`</span><span class="token punctuation" style="color: rgb(199, 146, 234);">,</span><span class="token plain"></span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">    </span><span class="token literal-property property">options</span><span class="token operator" style="color: rgb(137, 221, 255);">:</span><span class="token plain"> </span><span class="token punctuation" style="color: rgb(199, 146, 234);">{</span><span class="token plain"></span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">      </span><span class="token literal-property property">baseUrl</span><span class="token operator" style="color: rgb(137, 221, 255);">:</span><span class="token plain"> </span><span class="token string" style="color: rgb(195, 232, 141);">"BASE_URL"</span><span class="token punctuation" style="color: rgb(199, 146, 234);">,</span><span class="token plain"> </span><span class="token comment" style="color: rgb(105, 112, 152); font-style: italic;">// Required</span><span class="token plain"></span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">      </span><span class="token literal-property property">websiteToken</span><span class="token operator" style="color: rgb(137, 221, 255);">:</span><span class="token plain"> </span><span class="token string" style="color: rgb(195, 232, 141);">"WEBSITE_TOKEN"</span><span class="token punctuation" style="color: rgb(199, 146, 234);">,</span><span class="token plain"> </span><span class="token comment" style="color: rgb(105, 112, 152); font-style: italic;">// Required</span><span class="token plain"></span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">      </span><span class="token literal-property property">includeInDevelopment</span><span class="token operator" style="color: rgb(137, 221, 255);">:</span><span class="token plain"> </span><span class="token boolean" style="color: rgb(255, 88, 116);">false</span><span class="token punctuation" style="color: rgb(199, 146, 234);">,</span><span class="token plain"> </span><span class="token comment" style="color: rgb(105, 112, 152); font-style: italic;">// Optional</span><span class="token plain"></span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">      </span><span class="token literal-property property">bcoorSettings</span><span class="token operator" style="color: rgb(137, 221, 255);">:</span><span class="token plain"> </span><span class="token punctuation" style="color: rgb(199, 146, 234);">{</span><span class="token punctuation" style="color: rgb(199, 146, 234);">}</span><span class="token punctuation" style="color: rgb(199, 146, 234);">,</span><span class="token plain"> </span><span class="token comment" style="color: rgb(105, 112, 152); font-style: italic;">// Optional</span><span class="token plain"></span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">    </span><span class="token punctuation" style="color: rgb(199, 146, 234);">}</span><span class="token punctuation" style="color: rgb(199, 146, 234);">,</span><span class="token plain"></span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain">  </span><span class="token punctuation" style="color: rgb(199, 146, 234);">}</span><span class="token punctuation" style="color: rgb(199, 146, 234);">,</span><span class="token plain"></span><br></span><span class="token-line" style="color: rgb(191, 199, 213);"><span class="token plain"></span><span class="token punctuation" style="color: rgb(199, 146, 234);">]</span><span class="token punctuation" style="color: rgb(199, 146, 234);">;</span><br></span></code></pre>
                                    <button type="button" aria-label="Copy code to clipboard" title="Copy"
                                        class="copyButton_eDfN clean-btn"><span class="copyButtonIcons_W9eQ"
                                            aria-hidden="true"><svg class="copyButtonIcon_XEyF" viewBox="0 0 24 24">
                                                <path
                                                    d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z">
                                                </path>
                                            </svg><svg class="copyButtonSuccessIcon_i9w9" viewBox="0 0 24 24">
                                                <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"></path>
                                            </svg></span></button>
                                </div>
                            </div>
                            <p>{{ $t('doc.setupInstruction.Gatsby.step2Note') }}</p>

                            <!-- <p>{{ $t('doc.setupInstruction.Gatsby.step2Note2') }} <a
                                    href="#"
                                    target="_blank" rel="noopener noreferrer">{{ $t('doc.setupInstruction.Gatsby.here') }}</a></p> -->
                        </div>
                        <div class="version-detail webflow" id="start-servere">
                            <h4>{{ $t('doc.setupInstruction.Gatsby.step3Title') }}</h4>
                            <p>{{ $t('doc.setupInstruction.Gatsby.step3Description') }}</p>
                        </div>
                        <div class="edit-update-detail">
                            <!-- <div class="edit-pen">
                                <svg fill="currentColor" height="20" width="20" viewBox="0 0 40 40" class="iconEdit_dcUD"
                                    aria-hidden="true">
                                    <g>
                                        <path
                                            d="m34.5 11.7l-3 3.1-6.3-6.3 3.1-3q0.5-0.5 1.2-0.5t1.1 0.5l3.9 3.9q0.5 0.4 0.5 1.1t-0.5 1.2z m-29.5 17.1l18.4-18.5 6.3 6.3-18.4 18.4h-6.3v-6.2z">
                                        </path>
                                    </g>
                                </svg>
                                <a href="#">{{ $t('doc.setupInstruction.Gatsby.editLink') }}</a>
                            </div> -->
                            <p>{{ $t('doc.setupInstruction.Gatsby.lastUpdated') }} <span class="dark">10/17/2022</span>{{ $t('doc.setupInstruction.Gatsby.updatedBy') }} <span class="dark">{{ $t('doc.setupInstruction.Gatsby.author') }}</span>
                            </p>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="create-chat-woot-account">
                                    <p class="preview">{{ $t('doc.setupInstruction.Gatsby.navigation.previous') }}</p>


                                    <router-link to="/docs/product/channels/live-chat/setup-instruction/vue"
                                        class="introduction-account">
                                        <span>«</span> {{ $t('doc.setupInstruction.Gatsby.navigation.vueJs') }}
                                    </router-link>



                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="create-chat-woot-account">
                                    <p>{{ $t('doc.setupInstruction.Gatsby.navigation.next') }}</p>
                                    <router-link to="/docs/product/channels/facebook">
                                        {{ $t('doc.setupInstruction.Gatsby.navigation.facebook') }} <span>»</span>
                                    </router-link>

                                </div>
                            </div>
                        </div>

                    </div>

                </div>
                <div class="col-xl-3 col-lg-4">
                    <section class="tableOfContents">
                    <div class="tableOfContents-list">
                        <ul id="side_section_info">
                        <li :class="{ 'active_menu_item': rightPanelMenuItem === '#copy-and-creates-link' }">
                            <a :id="'#copy-and-creates-link'" @click="scrollTo('#copy-and-creates')">
                            {{ $t('doc.setupInstruction.Gatsby.step1Title') }}
                            </a>
                        </li>
                        <li :class="{ 'active_menu_item': rightPanelMenuItem === '#Gatsby-file-link' }">
                            <a :id="'#Gatsby-file-link'" @click="scrollTo('#Gatsby-file')">
                            {{ $t('doc.setupInstruction.Gatsby.step2Title') }}
                            </a>
                        </li>
                        <li :class="{ 'active_menu_item': rightPanelMenuItem === '#start-servere-link' }">
                            <a :id="'#start-servere-link'" @click="scrollTo('#start-servere')">
                            {{ $t('doc.setupInstruction.Gatsby.step3Title') }}
                            </a>
                        </li>
                        </ul>
                    </div>
                    </section>
                </div>
            </div>

        </div>
    </section>
</template>
<script>
export default ({
    name: 'AddConfigure',
    data() {
        return {
            activeMenuItem: null,
            rightPanelMenuItem: null
        };
    },
    mounted() {
        window.addEventListener('scroll', this.setActiveMenuItem);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.setActiveMenuItem);
    },
    methods: {

        scrollTo(selector) {
            const element = document.querySelector(selector);
            if (element) {
                const offset = 106;
                const bodyRect = document.body.getBoundingClientRect().top;
                const elementRect = element.getBoundingClientRect().top;
                const elementPosition = elementRect - bodyRect;
                const offsetPosition = elementPosition - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth",
                });
                this.rightPanelMenuItem = `${selector}-link`
            }
        },
        setActiveMenuItem() {
            const scrollPosition = window.scrollY;
            const menuItems = document.querySelectorAll('#side_section_info li');
            this.activeMenuItem = null
            for (let i = menuItems.length - 1; i >= 0; i--) {
                const menuItem = menuItems[i];
                // console.log(menuItem)
                const target = document.querySelector(menuItem.querySelector('a').getAttribute('id')?.replace(/-link(?=[^-]*$)/, ""));
                if ((target?.offsetTop - 200) <= scrollPosition) {
                    let tempEle
                    if (menuItem) {
                        tempEle = menuItem?.getAttribute('id')
                        let targetID = target?.getAttribute('id')
                        this.rightPanelMenuItem = `#${targetID}-link`
                        // menuItem?.classList.add("active_menu_item");
                    }
                    this.activeMenuItem = tempEle
                    return;
                }
            }
        },
        isActiveSection(index) {
            return index === this.activeSectionIndex;
        }
    },
})
</script>
<style>
.finsh-img img {
    width: 100%;
    height: 100%;
}

.finsh-img {
    padding: 0 36px;
    margin-bottom: 30px;
}
</style>